
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-blue-600" style={{ fontFamily: '"Pacifico", serif' }}>
              logo
            </h1>
          </div>
          
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <button 
                onClick={() => scrollToSection('inicio')}
                className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer"
              >
                Inicio
              </button>
              <button 
                onClick={() => scrollToSection('productos')}
                className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer"
              >
                Productos
              </button>
              <button 
                onClick={() => scrollToSection('servicios')}
                className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer"
              >
                Servicios
              </button>
              <button 
                onClick={() => scrollToSection('preguntas')}
                className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer"
              >
                FAQ
              </button>
              <button 
                onClick={() => scrollToSection('contacto')}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                Contacto
              </button>
            </div>
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-blue-600 p-2 cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t">
              <button 
                onClick={() => scrollToSection('inicio')}
                className="block text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium w-full text-left cursor-pointer"
              >
                Inicio
              </button>
              <button 
                onClick={() => scrollToSection('productos')}
                className="block text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium w-full text-left cursor-pointer"
              >
                Productos
              </button>
              <button 
                onClick={() => scrollToSection('servicios')}
                className="block text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium w-full text-left cursor-pointer"
              >
                Servicios
              </button>
              <button 
                onClick={() => scrollToSection('preguntas')}
                className="block text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium w-full text-left cursor-pointer"
              >
                FAQ
              </button>
              <button 
                onClick={() => scrollToSection('contacto')}
                className="block bg-blue-600 text-white px-3 py-2 rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors w-full text-left cursor-pointer whitespace-nowrap"
              >
                Contacto
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
